$(document).foundation();

$(function() {
    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $(document).on('click', '.icon-menu', function() {
        $(this).toggleClass('open');
        $('#dropdown-menu').toggleClass('open');
        $('#header').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
        
        if ($(this).hasClass('open')) {
            $('#nav-shade').fadeIn(300);
        } else {
            $('#nav-shade').fadeOut(300);
        }
    });

    $(document).on('click', '#nav-shade', function() {
        $('.icon-menu').removeClass('open');
        $('#dropdown-menu').removeClass('open');
        $('#header').removeClass('menu-open');
        $('body').removeClass('menu-open');
        $('#nav-shade').fadeOut(300);
    });
    //---------------------------------------------------------

    //---------------------------------------------------------
    // Page Specific JS
    //---------------------------------------------------------
    if ($('.ProjectPage').length > 0) {
        
        $(document).ready(function() {
            var status = $("#project-status").data("id");
            
            if (status=='Completed'){
                $( "#status-completed" ).click();
            }
            else if (status=='Current'){
                $( "#status-current" ).click();
            }
            else{
                $( "#status-all" ).click();
            }
        });

        $(document).on('click', '.project-status-item', function() {
            var currentStatus = $(this).data('status');
            $('.project-status-item').removeClass('active');
            $(this).addClass('active');

            if (currentStatus=='All'){
                $('.project-tile').show();
            }
            else{
                $('.project-tile').hide();
                $('.'+currentStatus).show();
            }
        });

        $('.sim-thumb').on('click', function() {
            $('.sim-thumb').removeClass("active");
            $('#main-project-image').attr('src', $(this).data('image'));
            $(this).addClass("active");
            $("#project-image-full-size").attr('href', $(this).data('imagefull'));
        })

        if ($('.project-thumbs').length > 0) {
            $('.project-thumbs').slick({
                infinite: true,
                slidesToShow: 5.5,
                slidesToScroll: 1,
                autoplay:true,
                speed: 600,
                appendArrows: $('.project-thumbs'),
                prevArrow:'<a class="slider-prev"><i class="fas fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fas fa-chevron-right"></i></a>',
                dots: false,
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                    }
                  },
                ]
            });
        }
    }//End ProjectPage

    if ($('.ListingPage').length > 0) {
        $(document).ready(function() {
            if ($('#family-type').length > 0) {
                var status = $("#family-type").data("id");
                
                if (status=='single'){
                    $( "#family-single" ).click();
                }
                else{
                    $( "#family-multi" ).click();
                }
            }

            if ($('#buy-type').length > 0) {
                var status = $("#buy-type").data("id");
                
                if (status=='Available'){
                    $( "#buy-available" ).click();
                }
                else if (status=='Coming'){
                    $( "#buy-coming" ).click();
                }
                else{
                    $( "#buy-all" ).click();
                }
            }
        });

        $(document).on('click', '.family-type-item', function() {
            var currentType = $(this).data('family');
            $('.family-type-item').removeClass('active');
            $(this).addClass('active');
            $('.listing-tile').hide();
            $('.'+currentType).show();
        });

        $(document).on('click', '.buy-type-item', function() {
            var currentType = $(this).data('buy');
            $('.buy-type-item').removeClass('active');
            $(this).addClass('active');

            if (currentType=='All'){
                $('.listing-tile').show();
            }
            else{
                $('.listing-tile').hide();
                $('.'+currentType).show();
            }
        });

        $('.sim-thumb').on('click', function() {
            $('.sim-thumb').removeClass("active");
            $('#main-project-image').attr('src', $(this).data('image'));
            $(this).addClass("active");
            $("#project-image-full-size").attr('href', $(this).data('imagefull'));
        })

        if ($('.floor-plan-container').length > 0) {
            $('.floor-plan-container').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:true,
                speed: 600,
                appendArrows: $('.floor-plan-wrap'),
                prevArrow:'<a class="slider-prev"><i class="fas fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fas fa-chevron-right"></i></a>',
                dots: false,
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                    }
                  },
                ]
            });
        }
        
        if ($('.project-thumbs').length > 0) {
            $('.project-thumbs').slick({
                infinite: true,
                slidesToShow: 4.5,
                slidesToScroll: 1,
                autoplay:true,
                speed: 600,
                appendArrows: $('.project-thumbs'),
                prevArrow:'<a class="slider-prev"><i class="fas fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fas fa-chevron-right"></i></a>',
                dots: false,
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                    }
                  },
                ]
            });
        }
    }//End ListingPage
    
    if ($('.ContactUsPage').length > 0) {
        $(document).on('click', '.submit-form', function(e) {
            e.preventDefault();
            var thisForm = $(this).closest("form");
            var submitForm=true;

            thisForm.find('input').each(function(){
                $(this).removeClass("required")
                if($(this).prop('required')){
                    if(!$(this).val()){
                        submitForm=false;
                        $(this).addClass("required")
                    }
                }
            });

            if(submitForm){
                $(this).hide();
                $('#submitting').removeClass('hide');
    
                $.ajax({type: "GET", url: "/api/v1/contactform", dataType: 'json', data: thisForm.serialize() })
                .done(function(data) {
                    $('#submitting').addClass('hide');
                    $('#submitted-success').removeClass('hide');

                    thisForm.find('input').each(function(){
                        $(this).val("");
                    });
                    thisForm.find('textarea').each(function(){
                        $(this).val("");
                    });

                })
                .fail (function (xhr) {
                    console.log('Error: ' + xhr.responseText);
                });
            }
        });
    }//End ContactUsPage
    //---------------------------------------------------------

});
